module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_tool1.0fdbf.png";